import type { HelpFile } from '../../types/help'
import { DelegationsTestIds } from '../../../testids/DelegationsTestIds'

export const delegationsHelp: HelpFile = {
  docPage: '/docs/my-iam/delegations',
  texts: {
    [DelegationsTestIds.delegationsList]:
      'Approval delegations let you temporarily hand off your approval authority to a colleague when you are unavailable.',
  },
}
